import * as classNames from 'classnames';
import ModalDialog from './modal-dialog_v2';
import * as React from 'react';
import style from './dialog.less';

interface DialogWrapper2Props extends React.ClassAttributes<any> {
    width?: number;
    height?: number;
    top?: number;
    left?: number;
    verticalAlignCenter?: boolean;
    title?: string;
    styleClassExternal?: string;
    containerId?: string;
    canClose?: boolean;
    onAfterClose?(): void;
    onResize?(size: any): void;
}

interface DialogWrapper2State {
    isOpen: boolean;
}

export interface DialogWrapable {
    setDialogWrapper(dialogWrapper: DialogWrapper2): any;
}

export default class DialogWrapper2 extends React.Component<DialogWrapper2Props, DialogWrapper2State> {

    constructor(props: any) {
        super(props);
        this.closeDialog = this.closeDialog.bind(this);
        this.state = {
            isOpen: true
        };
        this.setStyle = this.setStyle.bind(this);
    }

    public closeDialog(): void {
        this.props.onAfterClose();
    }

    render(): JSX.Element {
        return (
            <div ref={this.setStyle}>
                <div className={style.modal} />
                <ModalDialog
                    title={this.props.title}
                    isOpen={this.state.isOpen}
                    containerId={this.props.containerId}
                    contentClassName={classNames(style.dialog, this.props.styleClassExternal)}
                    width={this.props.width ? (this.props.width === -1 ? 'auto' : this.props.width) : '100%'}
                    height={this.props.height ? this.props.height : 'auto'}
                    top={this.props.top}
                    left={this.props.left}
                    verticalAlignCenter={this.props.verticalAlignCenter}
                    canClose={this.props.canClose}
                    onAfterClose={this.closeDialog}
                    onResize={this.props.onResize}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1, overflowY: 'hidden' }}>
                        {this.props.children}
                    </div>
                </ModalDialog>
            </div>
        );
    }

    setStyle(ref: any): void {
        if (!ref) {
            return;
        }
        ref.parentElement.style.left = 'auto';
        ref.parentElement.style.alignSelf = 'center';
        ref.parentElement.style.display = 'none';
        window.setTimeout(() => ref.parentElement.style.display = 'block');
    }
}
